import { Button } from '@repo/go-ui';
import { useTranslation } from 'react-i18next';

import { wrap } from 'src/packages/mobx-di/wrap';
import { hasValue } from 'src/packages/utils/has-value';

import type { RefreshLogs } from './refresh-logs';

export const RefreshLogsButton = wrap<{ pluginController: RefreshLogs }>(function RenderButton({ pluginController }) {
  const { t } = useTranslation();

  return (
    <Button
      onClick={pluginController.refreshLogs}
      disabled={!hasValue(pluginController.generalDataWellId) || pluginController.directoryPageService.isEditing}
      loading={pluginController.isLoading}
      style={{ textWrap: 'nowrap' }}
    >
      {t('plugins:RefreshLogs.button')}
    </Button>
  );
});

export function renderRefreshLogsButton(pluginController: RefreshLogs) {
  return <RefreshLogsButton pluginController={pluginController} />;
}
